import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Button from "@material-ui/core/Button";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import {Typography} from "@material-ui/core";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import logo from '../../assets/img/thomaspironresize.jpg'

import './style.css'
import InfoModal from "../InfoModal/InfoModal";
import webicon from "../../assets/img/webicongrey.png";
import fb from "../../assets/img/fbgrey.png";
import Menu from "../Menu/Menu";


const sceneBloc = {
    'AVANT': ['pano'],
    'ARRIERE': ['pano2'],
    'REZ-DE-CHAUSSEE': ['pano3','pano4'],
    'ETAGE': ['pano5','pano6','pano7','pano8', 'pano9'],

}

const useStyles = makeStyles({
    list: {
        width: 150,
        boxShadow: 'none'
    },
    fullList: {
        width: 'auto',
    },
    paper: {
        backgroundColor: 'none'
    }
});

const theme = createMuiTheme({
    overrides: {
        MuiExpansionPanelDetails: {
            root: {
                maxWidth: '350px !important'
            },
            modal: {
                maxWidth: '50% !important'
            }
        }
    }
})



export default function Sidebar({scenes}) {
    const classes = useStyles();
    const [state, setState] = React.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });


    const toggleDrawer = (side, open) => event => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [side]: open });
    };

    const goToScene = (scene) => {
        const { krpano } = window;
        console.log(scene)
        krpano.call(`loadscene('${scene}')`)
    }

    const sideList = side => (
        <div
            className={classes.list}
            role="presentation"
            onClick={toggleDrawer(side, false)}
            onKeyDown={toggleDrawer(side, false)}
        >
        </div>
    );

    const [expanded, setExpanded] = React.useState('panel1');

    const handleChange = panel => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    const fullList = side => (
        <div
            className={classes.fullList}
            role="presentation"
            onClick={toggleDrawer(side, false)}
            onKeyDown={toggleDrawer(side, false)}
        >
        </div>
    );

    return (
        <div style={{position:'absolute', top:'36px', left:'36px', zIndex:"10"}}>
            <Button onClick={toggleDrawer('left', true)}> <svg xmlns="http://www.w3.org/2000/svg" fill='#DF001B' width="64" height="64" viewBox="0 0 24 24"><path d="M2 15.5v2h20v-2H2zm0-5v2h20v-2H2zm0-5v2h20v-2H2z"/></svg> </Button>
            <Drawer style={{zIndex:"11"}} open={state.left} onClose={toggleDrawer('left', false)}>
                {sideList('left')}
                <a style={{float:"right", marginTop:"5px", color:"#E53118"}} width={"10px"} onClick={toggleDrawer('left',false)}><i className="material-icons" style={{float:"right", cursor:"pointer"}}>close</i></a>
                <img src={logo} alt={'tpLogo'} width={"140px"} style={{margin: "0 auto", marginTop:"5px", marginBottom:"15px"}}/>
                {Object.keys(sceneBloc).map(bloc => (
                    <ExpansionPanel style={{background:'#FFFFFF'}} key={bloc} square expanded={expanded === bloc} onChange={handleChange(bloc)}>
                        <ExpansionPanelSummary>
                            <Typography style={{color:'#E53118', fontWeight: 'bold', margin: '0 auto'}}>{ bloc }</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            {scenes.filter(scene => sceneBloc[bloc].includes(scene.title)).map(scene => <a onClick={toggleDrawer('left',false)}><img key={scene.name} alt={scene.title} src={scene.thumburl} style={{margin:"10px"}} width={'50px'} height={'50px'} onClick={() => goToScene(scene.name)} /></a>)}
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                ))}
                <InfoModal/>
                <Menu/>
                <div style={{display: 'flex', justifyContent: 'center'}}>
                    <a href="https://www.thomas-piron.eu/" target="_blank"><img width="40px" src={webicon}/></a>
                    <a href="https://fr-fr.facebook.com/thomasetpiron" target="_blank"><img width="40px" src={fb}/></a>
                </div>
            </Drawer>

        </div>
    );
}
